module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orgName) ? _c('span', {
    style: ('border-bottom: 5.28px solid ' + _vm.colour + '80')
  }, [_c('b', {
    class: _vm.colour ? 'text-black' : 'text-black'
  }, [_vm._v(_vm._s(_vm.orgName))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d28a51fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/OrgBadge.vue
// module id = 1632
// module chunks = 0